import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'RMApprove',
  components: {
      Multiselect,
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        fromDate : '',
        toDate:'',
        searchflag:false,
        localuserid:'',
        localusermailid:'',
        pageno: 1,
        pagecount: 0,
        hubname:'',
        debitFrom:'',
        ShippingId:'',
        ShipmentData:'',
        raiseRMDebitNoteEditflag:false,
        getShipmentsflag:false,
        getDebitAmountflag:false,
        getShipmentslogData:[],
        getShipmentsSummeryData:[],
        getDebitAmountData:[],
        raiseRMDebitNoteData:[],
        selectedItems: [],
        getDebitAmountDataLog:[],
        selectAllItems: false,
        selectedItemsonPopup:[],
        selectAllItemsonPopup: false,
        raiseRMDebitNotecomment:'',
        DebitShareinRs:'',
        Percentage:'',
        hubID:[],
        hubzoneid:'',
        hubList:[],
        hubZoneList:[],
        amount:0,
        // RMApproveAllRecord:'',
        selectEditItemsList : [],
        isAPICallFlag : true,
        adjustDebitAmount : 0,
        isDebitPersonSelected : "",
        getShippingIdforLog : "",
        debitPersonAmount :[],
        debitPersonPercent :[],
        getShipmentLostMasterID : '',
        getShipmentLostDetailsID : [],
        ShipmentLostMasterID : '',
        Loading: false,
        LoaderForPopup:false,
        localhubdetails: '',
        hubinfo: '',
        getAttachmentListData: [],
        getInvestigationImgs:[],
        getAttachmentFlag: false,
        attachmentLoader: false,
        RmApproveLoaderBtn: false,
        totalRecords:0,
        totalSelectedRecords:0,
        ExportRmApproveLoaderBtn: false,
        approvalDebitResultStatus: [],
        isPendingGroupIdLoader: false,
        modelValue: false,
        styleObjectFailure : {
          'background-color' : 'red'
        },
        styleObjectSuccess: {
          'background-color' : 'green'
        },
        selectAllItems: false,
        newid : [],
        Vertical : '',
        awbnumbers: '',
        ShipmentType: '',
        CenterTypeList: [],
        CenterType : '',
        hubStateList : [],
        hubCitybyStateList : [],
        hubNameList : [],
        hubStateId : '',
        hubCityId : '',
        AORList : [],
        AOR : '',
        selectedHubZoneId : '',
        selectedStateId : '',
        selectedCityId : '',
        selectedAOR : '',
        selectedCenterType : '',
        filteredHubList : [],
        usernames : '',
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        debitFromModal : false,
        debitPersonDetails : null,
        userDataKey : '',
        heading: '',
        hubAccessList: [],
        selectAll: false,
        allhubList: [],
        masterHubList: [],
        isReport:false,
        isShow:true,
        dashboardDetails:{},
        overAllDetails:{},
        GrantTotalRecovedYTD:0,
        RecoveredAmountCount:0,
        GrandTotalRMApproveYTD:0,
        RMApprovalCount:0,
        year:'',
        showModal: false,
        isFacility:false,
        // approveType:'',
        selectedItemsdetails:[],
        // facilityArr:[],
        // isApprove:false,
        totalDebitAmount:0,
        addDebitAmt:0,
        Itemselected: null,
        isScroll:false,
        isLoading: false,
        debitDetailsFull: [],
        source: "",
        resetKey: '',
        userInfo:{},
        isPotentialDebitsPresent: false
      }
  },
  created: function() {
  },
async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    // this.getHubList("hubList");
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.userInfo = userdetail;
    this.LoggedInUserJobProfile = userdetail.jobProfile
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubinfo  = await this.getHubDetailsbyID(this.localuserid, this.localhubdetails);
    // console.log('Mixin is working for :',userdetail);
    this.userRoleList = userdetail.userrole.map((role) => role.rolename.toLowerCase());

    if(this.userRoleList.includes('StateHeadApproved') || this.userRoleList.includes('stateheadapproved')) {
      this.heading="StateHead Approve";
    } else if(this.userRoleList.includes('ClusterHeadApproved') || this.userRoleList.includes('clusterheadapproved')) {
      this.heading="ClusterHead Approve"
    } else {
      this.heading="RM Approve"
    };
    console.log('this.userRoleList ------>>', this.userRoleList);
    let getHubList = localStorage.getItem('allhubaccesslist');
    var byteHub = CryptoJS.AES.decrypt(getHubList.toString(), this.userDataKey);
    var hubList = byteHub.toString(CryptoJS.enc.Utf8);
    this.hubAccessList = JSON.parse(hubList);
    var date = new Date();
    this.year = date.getFullYear();
    this.getHubZoneList();
    this.getCenterTypeList();
    this.getServiceCentreList("");
    this.getHubStateList();
    this.getAORList();
    this.getDashboardDetails();
    console.log('this.hubAccessList ----------->>', this.hubAccessList);
  },


  methods : {
    getDebitFromId(val) {
      switch (val.DebitFromType) {
        case 'ServiceCenter':
          return val.UserID;
        case 'Store':
        case 'RSC':
        case 'BranchDebit':
          return val.DebitID;
        case 'Coloader':
          return val.ColoaderID;
        case 'Vendor':
        case 'NetworkVendor':
          return val.VehicleVendorID;
        case 'Courier':
          return val.CourierID;
        default:
          return '';
      }
    },
    calculateselectedcount(event,shipmentDetail) {
      console.log("shipmentDetail ============>>", shipmentDetail);
      if(shipmentDetail.DebitFromType=="BranchDebit"){
          this.isFacility=true;
      }
      this.selectedItemsdetails.push(shipmentDetail)
      this.totalSelectedRecords = this.selectedItems.length
      const checkbox = event.target;
      const checkboxValue = parseInt(shipmentDetail.DebitAmount);
      if (checkbox.checked) {
        this.addDebitAmt += parseFloat(checkboxValue);
        this.totalDebitAmount=this.addDebitAmt.toFixed(2)
      } else {
        this.addDebitAmt-= parseFloat(checkboxValue);
        this.totalDebitAmount=this.addDebitAmt.toFixed(2)
        // Remove the deselected item from the selectedItems array
        this.selectedItems = this.selectedItems.filter(item => item.value !== checkboxValue);
        // console.log("this.selectedItems AFTER=============>>", this.selectedItems);
      }
      this.totalDebitAmount=parseFloat(this.totalDebitAmount)
      this.checkIsPotentialLostShipmentExist(this.selectedItems);
    },
    checkIsPotentialLostShipmentExist(selectedItemsVals) {
      let isPotentialList = [];
      for (let i = 0; i < selectedItemsVals.length; i++) {
        let result = this.ShipmentData.find( shipmentData => shipmentData.ShippingID == this.selectedItems[i] );
        if( result.ispotentiallost && !result.ShipmentLostMasterID ) {
          console.log("Is potential Lost.");
          isPotentialList.push(result)
        }
      }
      console.log("isPotentialList ======>>", isPotentialList);
      this.isPotentialDebitsPresent = isPotentialList.length > 0 ? true : false

    },
   uncheckAll() {
      // Select all checkboxes inside the form with id "myForm"
      const checkboxes = document.querySelectorAll('#batchTable input[type="checkbox"]');

      // Iterate through each checkbox and uncheck it
      checkboxes.forEach(checkbox => {
          checkbox.checked = false;
      });
    },
    searchData() {
      if (this.usernames && !this.reg.test(this.usernames)) {
        this.$alertify.error('Please enter a valid email address');
        return false
      }
      // this.RMApproveAllRecord = false
      this.searchflag = true
      this.pageno = 1
      this.selectedItems = []
      this.totalSelectedRecords = 0
      this.totalDebitAmount=0;
      this.addDebitAmt=0;
      this.selectAllItems = false
      this.$refs.paginate.selected= 0;
      this.SearchShipmets()
    },
    SearchShipmets(){
      if(this.toDate >= this.fromDate ){
        //this.searchflag=true;
        this.Loading = true;
        this.searchflag = true;

        let hubIDarray = []
        if(this.hubID.length > 0 ){
          this.hubID.map(hub=>{
            hubIDarray.push(hub.HubID)
          })
        }else{
          if(this.filteredHubList.length > 0){
            this.filteredHubList.map(hub=>{
              hubIDarray.push(hub.HubID)
            })
          }else{
            this.Loading = false;
            this.ShipmentData=[];
            this.totalRecords=0;
            this.pagecount = 0;
            this.$alertify.error("No SVC found for selected filter's..!")
            return false;
          }

        }
        if (this.ShipmentType =="All"){
          this.ShipmentType = ""
        }
        let data={
            fromDate:this.fromDate ,
            toDate: this.toDate,
            HubZoneID: this.hubzoneid,
            DebitFromType: this.debitFrom,
            HubId: hubIDarray,
            Vertical: this.Vertical,
            CenterType: this.CenterType,
            offset : this.pageno - 1,
            limit : 100,
            ShippingID:this.awbnumbers,
            isCsvDownload: false,
            ShipmentType : this.ShipmentType,
            AOR : this.AOR,
        };
        if (this.awbnumbers.length>0) {
         let shippingId=this.awbnumbers.split(/[\s,]+/);
         let shipmentReqArray = [];
         $.each(shippingId, (key,shipmentId)=>{
           if(shipmentId != ''){
             shipmentReqArray.push(shipmentId.trim())
           }
           if(shipmentReqArray.length > 100){
             this.$alertify.error("Maximum 100 shippingID you can enter.")
           }else{
             data.ShippingID = shipmentReqArray;
           }
         })
       }
        if (this.usernames){
          let userNameArr = []
          userNameArr.push(this.usernames)
          data.username = userNameArr
        }
        if (this.source){
          data.source = this.source
        }
        data.userid = this.localusermailid
        axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getShipmentList',data)
          .then((response) => {
            console.log('response.data ----->', response.data);
            if(response.data.code == 200){
              this.searchflag=true;
              this.ShipmentData = response.data.data;
              this.ShipmentData.map(data => {
                if (Array.isArray(data.shipmentlostdebitdetails) && data.shipmentlostdebitdetails.length > 0) {
                  data.shipmentlostdebitdetails.map(data2 => {
                    data.DebitDate = data2!=null?data2.CreatedDate:'-'//!= undefined ? data.ShipmentLostDebitDetails[0].CreatedDate : ""
                  })
                }
                // console.log("DATA =============>>>", data);
                const gethub = this.hubAccessList.find(hub => hub.HubID === data.CurrentHubID);
                const getzone = data.HubZoneID ? this.hubAccessList.find(zone => zone.HubZoneId == data.HubZoneID) : 'undefined';
                // console.log("getzone =========>>", getzone);
                data.HubName = gethub && gethub.HubID ? gethub.HubName : data.HubName
                data.HubZoneName = getzone && getzone.HubZoneId ? getzone.hubzonename : data.HubZoneName
                let debitgreatureamount = parseFloat(data.NetPayment) > parseFloat(data.OctroiMRP) ? data.NetPayment : data.OctroiMRP
                data.NetShipmentValue = debitgreatureamount;
                data.DebitAmount = debitgreatureamount;
              })
              this.Loading = false;
               let totalRows = response.data.totalCount;
               this.totalRecords = totalRows
               if (totalRows < 100) {
                   this.pagecount = 1;
               } else {
                   this.pagecount = Math.ceil(totalRows / 100)
               }
            }else if(response.data.code == 204) {
              this.searchflag= false;
              this.Loading = false;
              this.ShipmentData = [];
              this.$alertify.error("No Pending Approval");
            }else if(response.data.code == 202) {
              this.Loading = false;
              this.ShipmentData = [];
              this.$alertify.error(response.data.message);
            }else{
              this.Loading = false;
              this.ShipmentData = [];
              this.$alertify.error(response.data.message);
            }
          })
        .catch((httpException) => {
            console.error('exception is:::::::::',httpException)
        });
      }
      else {
        this.$alertify.error("To Date is greter than from Date");
      }
  },
     debitNoteSubmit(){

       let getDetails = this.raiseRMDebitNoteData;
     },
     exportForm(){

     },
     getHubList(hubZoneID){
       let url = 'UpdateShipment/gethublist';
       if(hubZoneID != 'hubList') url = `external/getzonewisehublist?zoneid=${hubZoneID}`;

       axios.get(apiUrl.api_url + url)
         .then((response) => {
             if(response.data.code ==200){
                 this.hubList=response.data.data;
                 this.hubList.sort(function(a, b){
                  var nameA=a.HubName.toLowerCase(), nameB=b.HubName.toLowerCase()
                  if (nameA < nameB) //sort string ascending
                   return -1
                  if (nameA > nameB)
                   return 1
                  return 0 //default return value (no sorting)
                 });
             }
             else {
                 this.hubList=[];
             }
         })
         .catch((httpException) => {
               this.$alertify.error("Hub List not found");
               console.error('exception is:::::::::', httpException)
         })
     },
     getHubZoneList(){
       //   axios.get(apiUrl.api_url + 'external/gethubzonelist')
       //   .then((response) => {
       //     this.hubZoneList = response.data.data;
       //   })
       // .catch((httpException) => {
       //     console.error('exception is:::::::::',httpException)
       // });
       /**
        Details used based on the user has hubaccess.
       */
       let hubZone=[]
        this.hubAccessList.filter(element=>{
          const existingIndex = hubZone.findIndex(item => item.HubZoneId === element.HubZoneId);
              if (existingIndex != -1) {
              hubZone[existingIndex] = element;
            } else {
              hubZone.push(element );
            }
        });
        this.hubZoneList=hubZone;
     },
  getCenterTypeList() {
    axios.post(apiUrl.api_url + 'external/getCentreTypeList')
      .then((response) => {
        if (response.data.code == 200) {
          console.log("response",response);
          this.CenterTypeList = response.data.data;
        }
        else {
          this.CenterTypeList = [];
          this.$alertify.error(response.data.message);

        }
      })
      .catch((httpException) => {
        console.error('exception is:::::::::', httpException)
      })
  },

     getRaiseRMDebitNoteForEdit(ShipmentLostID){
       const reqShipments = [ShipmentLostID]; // array defined.
       const shippingIds = JSON.stringify(reqShipments)
       // this.$router.push({
       //   name: 'Hub Mark LostDebit',
       //   path: '/HubMarkLostDebit',
       //   query: { id: shippingIds,reason:this.lostreason },
       //   component: 'HubMarkLostDebit'
       // });
      this.$router.push({
        name: 'Edit Debit',
        path: '/EditDebit',
        query: { id: shippingIds },
        component: 'EditDebit'
      });

      return false;
       this.raiseRMDebitNoteEditflag= true;
       this.LoaderForPopup = true ;
      //  let data={
      //    ShipmentLostMasterID:ShipmentLostID
      //  }
      //  axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getDebitDetails',data)
      //    .then((response) => {
      //      let data1={
      //        userdetail:response.data.data
      //      }
      //      axios.post(apiUrl.api_url + 'external/getEmpName',data1)
      //        .then((response1) => {
      //          if(response1.data.code == 200){
      //             this.LoaderForPopup = false ;
      //             this.raiseRMDebitNoteData = response1.data.data;
      //             let sumofAllDebitAmount=0;
      //               let getResult = response1.data.data;

      //               for(let i=0; i< getResult.length;i++){
      //                 if(getResult[i].DebitFromType == "ServiceCenter"){

      //                   this.selectEditItemsList.push(getResult[i].UserID);
      //                   this.debitPersonAmount[parseInt(getResult[i].UserID)] = parseFloat(getResult[i].DebitAmount);
      //                   this.debitPersonPercent[parseInt(getResult[i].UserID)] = parseFloat(getResult[i].DebitPercentage);
      //                   this.getShipmentLostDetailsID[parseInt(getResult[i].UserID)] = parseFloat(getResult[i].ShipmentLostDetailsID);

      //                 }else if(getResult[i].DebitFromType == "Vendor" || getResult[i].DebitFromType == "NetworkVendor"){

      //                   this.selectEditItemsList.push(getResult[i].VehicleVendorID);
      //                   this.debitPersonAmount[parseInt(getResult[i].VehicleVendorID)] = parseFloat(getResult[i].DebitAmount);
      //                   this.debitPersonPercent[parseInt(getResult[i].VehicleVendorID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
      //                   this.getShipmentLostDetailsID[parseInt(getResult[i].VehicleVendorID)] = parseFloat(getResult[i].ShipmentLostDetailsID);

      //                 }else if(getResult[i].DebitFromType == "Coloader"){

      //                   this.selectEditItemsList.push(getResult[i].ColoaderID);
      //                   this.debitPersonAmount[parseInt(getResult[i].ColoaderID)] = parseFloat(getResult[i].DebitAmount);
      //                   this.debitPersonPercent[parseInt(getResult[i].ColoaderID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
      //                   this.getShipmentLostDetailsID[parseInt(getResult[i].ColoaderID)] = parseFloat(getResult[i].ShipmentLostDetailsID);
      //                 }else if(getResult[i].DebitFromType == "Courier"){

      //                   this.selectEditItemsList.push(getResult[i].CourierID);
      //                   this.debitPersonAmount[parseInt(getResult[i].CourierID)] = parseFloat(getResult[i].DebitAmount);
      //                   this.debitPersonPercent[parseInt(getResult[i].CourierID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
      //                   this.getShipmentLostDetailsID[parseInt(getResult[i].CourierID)] = parseFloat(getResult[i].ShipmentLostDetailsID);
      //                 }
      //                 sumofAllDebitAmount = parseFloat(sumofAllDebitAmount)+ parseFloat(getResult[i].DebitAmount);

      //               }

      //             this.isDebitPersonSelected = this.selectEditItemsList.length;
      //             this.amount = sumofAllDebitAmount;
      //             this.getShipmentLostMasterID = ShipmentLostID;
      //          }else if (response1.data.code=204) {
      //            this.LoaderForPopup = false ;
      //            this.raiseRMDebitNoteData = [];
      //          }else if (response1.data.code=202) {
      //            this.LoaderForPopup = false ;
      //            this.raiseRMDebitNoteData = [];
      //          }else {
      //            this.LoaderForPopup = false ;
      //            this.raiseRMDebitNoteData = [];
      //          }
      //        });

      //    })
      //  .catch((httpException) => {
      //      console.error('exception is:::::::::',httpException)
      //  });


        const filteredData= this.ShipmentData.filter(x=> x.ShipmentLostMasterID=== parseInt(ShipmentLostID));
        this.raiseRMDebitNoteData=filteredData[0].shipmentlostdebitdetails;

        if(this.raiseRMDebitNoteData.length > 0){
          this.LoaderForPopup = false ;
          let sumofAllDebitAmount=0;
            let getResult = this.raiseRMDebitNoteData;
            for(let i=0; i< getResult.length;i++){
              if(getResult[i].DebitFromType == "ServiceCenter"){
                this.selectEditItemsList.push(getResult[i].UserID);
                this.debitPersonAmount[parseInt(getResult[i].UserID)] = parseFloat(getResult[i].DebitAmount);
                this.debitPersonPercent[parseInt(getResult[i].UserID)] = parseFloat(getResult[i].DebitPercentage);
                this.getShipmentLostDetailsID[parseInt(getResult[i].UserID)] = parseFloat(getResult[i].ShipmentLostDetailsID);
              }else if(getResult[i].DebitFromType == "Vendor" || getResult[i].DebitFromType == "NetworkVendor"){

                this.selectEditItemsList.push(getResult[i].VehicleVendorID);
                this.debitPersonAmount[parseInt(getResult[i].VehicleVendorID)] = parseFloat(getResult[i].DebitAmount);
                this.debitPersonPercent[parseInt(getResult[i].VehicleVendorID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
                this.getShipmentLostDetailsID[parseInt(getResult[i].VehicleVendorID)] = parseFloat(getResult[i].ShipmentLostDetailsID);

              }else if(getResult[i].DebitFromType == "Coloader"){

                this.selectEditItemsList.push(getResult[i].ColoaderID);
                this.debitPersonAmount[parseInt(getResult[i].ColoaderID)] = parseFloat(getResult[i].DebitAmount);
                this.debitPersonPercent[parseInt(getResult[i].ColoaderID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
                this.getShipmentLostDetailsID[parseInt(getResult[i].ColoaderID)] = parseFloat(getResult[i].ShipmentLostDetailsID);
              }else if(getResult[i].DebitFromType == "Courier"){

                this.selectEditItemsList.push(getResult[i].CourierID);
                this.debitPersonAmount[parseInt(getResult[i].CourierID)] = parseFloat(getResult[i].DebitAmount);
                this.debitPersonPercent[parseInt(getResult[i].CourierID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
                this.getShipmentLostDetailsID[parseInt(getResult[i].CourierID)] = parseFloat(getResult[i].ShipmentLostDetailsID);
              }
              else if(getResult[i].DebitFromType == "Store" || getResult[i].DebitFromType == "RSC" || getResult[i].DebitFromType == "BranchDebit"){

                this.selectEditItemsList.push(getResult[i].DebitID);
                this.debitPersonAmount[parseInt(getResult[i].DebitID)] = parseFloat(getResult[i].DebitAmount);
                this.debitPersonPercent[parseInt(getResult[i].DebitID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
                this.getShipmentLostDetailsID[parseInt(getResult[i].DebitID)] = parseFloat(getResult[i].ShipmentLostDetailsID);
              }
              sumofAllDebitAmount = parseFloat(sumofAllDebitAmount)+ parseFloat(getResult[i].DebitAmount);

            }

          this.isDebitPersonSelected = this.selectEditItemsList.length;
          this.amount = sumofAllDebitAmount;
          this.getShipmentLostMasterID = ShipmentLostID;
      }
      else  {
        this.LoaderForPopup = false ;
        this.raiseRMDebitNoteData = [];
      }

     },

     approveAllRecolrd(){
      // console.log(this.selectedItems,">>>>>>>>>>>>>>>>>>>");

       if(this.selectedItems.length == 0){
         this.$alertify.error("please select atleast one Record");
       }else {

            let endResult=[];
            for (let i = 0; i < this.selectedItems.length; i++) {
              let result = this.ShipmentData.find( shipmentData => shipmentData.ShippingID == this.selectedItems[i] );
              endResult.push(result)
            }
            // console.log("endResult =========>>", endResult);
            const hasBranchDebit = endResult.some(
              obj => obj['DebitFromType'] === 'BranchDebit'
            );
            if(hasBranchDebit) {
              this.$alertify.error("Branch debits are not eligible for RM approval. Please exclude branch debits using the ‘Debit From’ filter.")
              return false;
            }
            console.log("endResult =========>>", endResult);


            let hasNullCategory = false;
            let hasNotNullCategory = false;

            for (let obj of endResult) {
              const isDebitNull =
                obj.DebitFromType === null ||
                obj.DebitFromType === '' ||
                obj.DebitFromType === 'null';

              const isPotentialLostTrue =
                obj.ispotentiallost === true;

              if (isDebitNull && isPotentialLostTrue) {
                // NULL category
                hasNullCategory = true;
              } else {
                // NOT NULL category
                hasNotNullCategory = true;
              }

              // Stop early if mixed
              if (hasNullCategory && hasNotNullCategory) break;

            }

            // Condition 1 → All NOT NULL
            if (hasNotNullCategory && hasNullCategory) {
              this.$alertify.error(
                "Mixed selection detected. Please select either Potential Lost or Confirm Lost shipments using the “Source” filter."
              );
              return false;
            }

            // Condition 3 → All NULL + Potential Lost true
            if (hasNullCategory && !hasNotNullCategory) {
              this.ApprovePotentialLostShipments(endResult);
              return true;
            }

            // console.log("hasPetetialLostShipments ===========>>>", hasPetetialLostShipments);
            this.RmApproveLoaderBtn = true
            let payload=[];
            for (let j = 0; j < endResult.length; j++) {
              let debitPersonDetailsArray=[];
              for (let p = 0; p < endResult[j].shipmentlostdebitdetails.length; p++) {
                let debitPersonDetailsobj={
                  ShipmentLostDetailsID:endResult[j].shipmentlostdebitdetails[p].ShipmentLostDetailsID,
                  DebitAmount:endResult[j].shipmentlostdebitdetails[p].DebitAmount,
                  DebitPercentage:endResult[j].shipmentlostdebitdetails[p].DebitPercentage
                }
                debitPersonDetailsArray.push(debitPersonDetailsobj);
              }
              this.newid.push(endResult[j].ShipmentLostMasterID)
              let data=  {
                            "ShipmentLostMasterID": endResult[j].ShipmentLostMasterID,
                            "DebitPersonDetails":debitPersonDetailsArray,
                            "Comments": "Success",
                            "LastModifiedBy":this.localusermailid,
                            "roles": this.userRoleList
                        }
                payload.push(data);
            }
            // payload.roles=this.userRoleList
            console.log("PayLoad.........", payload)
            axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/approveDebit',payload)
            .then((response) => {
              let masterID = String(this.newid)
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.localuserid,
                username:this.localusermailid,
                meta :
                {
                  "event":"RMApproval",
                  "ShipmentLostMasterID" : masterID
                }
              }
              this.PageTracker(TrackerInfo);
              this.modelValue = true
              this.approvalDebitResultStatus = response.data.data;
              this.approvalDebitResultStatus.forEach((obj) => {
                this.ShipmentData.find(shipmentData => {
                  if( shipmentData.ShipmentLostMasterID == obj.ShipmentLostDetailsID) {
                    obj.shippingIDs = shipmentData.ShippingID
                  }
                })
              })
              let vm = this
              setTimeout(function(){
                vm.modelValue = false
                vm.searchData();
              }, 20000);
              if(response.data.code=200){
                  // this.$alertify.success(response.data.message);
                  this.selectedItems = [];
              } else if(response.data.code=202) {
                // this.$alertify.error(response.data.message);
              }else {
                // this.$alertify.error("Internal server Error");
              }
              //  this.RMApproveAllRecord=false;
              this.RmApproveLoaderBtn = false
              this.totalSelectedRecords = 0
            })
          .catch((httpException) => {
            // this.RMApproveAllRecord=false;
            this.RmApproveLoaderBtn = false
            this.totalSelectedRecords = 0
            this.totalDebitAmount=0;
            this.addDebitAmt=0;
              console.error('exception is:::::::::',httpException)
          });
       }
     },

     approveBranchDebit(type){
      let approveType=type;
      if(approveType==="Self/Branch"){
        // let found = this.selectedItemsdetails.some(obj => obj.DebitFromType === "BranchDebit");
        console.log("=-=-=-=-=--=", this.selectedItemsdetails)
          const count = this.selectedItemsdetails.filter(obj => obj.DebitFromType === "BranchDebit").length;
          if(count!=this.selectedItems.length){
              // this.RMApproveAllRecord=false;
              this.isFacility=false;
              this.selectedItems=[];
              this.selectedItemsdetails=[];
              this.totalDebitAmount=0;
              this.addDebitAmt=0;
              this.uncheckAll()
              this.$alertify.error("Only branch debits are eligible for conversion to company debit. Please use the Debit from filter to see only branch debits eligible for marking as Company Debit.");
              return false;
            }
      }
      if(this.selectedItems.length == 0){
        this.$alertify.error("please select atleast one Record");
      }else {
        // let ShipmentLostMasterID=this.selectedItems.map(item => item).join(', ');
        let message={}
        if(approveType==="Rejected"){
          message = {
            title: '',
            body: ` <div class="row">
                      <div class="col-md-12">
                        <span style="font-size: 15px; ">Are you sure you want to <b>REJECT</b> all the selected debits?</span>
                      </div>
                    </div>`,
          }
        }else{
           message = {
            title: '',
            body: ` <div class="row">
                      <div class="col-md-12">
                        <span style="font-size: 15px;"> Are you sure you want to convert all selected shipments to <b>Company Debit?</b></span>
                      </div>
                    </div>`,
          }
        }

        this.$dialog.confirm(message, {
          html: true,
          animation: 'bounce',
          backdropClose: true,
          okText: 'Yes',
          cancelText: 'No',
          reverse: true
          //loader: true
        })
        .then(dialog => {

          this.RmApproveLoaderBtn = true
          let shipmentLostmasterid = [];
          for (let i = 0; i < this.selectedItems.length; i++) {
            let result = this.ShipmentData.find( shipmentData => shipmentData.ShippingID == this.selectedItems[i] );
            // endResult.push(result)
            shipmentLostmasterid.push(result.ShipmentLostMasterID);
          }

          let payload=  {
                       "ShipmentLostMasterID": shipmentLostmasterid,
                       "Comments": "Success",
                       "LastModifiedBy":this.localusermailid,
                       "Status": approveType
                   }
        // console.log("PayLoad.........", payload)
        axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/ApproveRejectDebit',payload)
        .then((response) => {
            // console.log(">>>>>>>>>>>>>>>>>>>>>>", response.data.data)
          let masterID = String(this.newid)
          let TrackerInfo = {
           projectname:"Last Mile",
           type:"Web",
           userid:this.localuserid,
           username:this.localusermailid,
           meta :
           {
             "event":"RMApproval",
             "ShipmentLostMasterID" : masterID
           }
         }
         this.PageTracker(TrackerInfo);
          this.modelValue = true
          this.approvalDebitResultStatus = response.data.data;
          this.approvalDebitResultStatus.forEach((obj) => {
            this.ShipmentData.find(shipmentData => {
              if( shipmentData.ShipmentLostMasterID == obj.ShipmentLostMasterID) {
                obj.shippingIDs = shipmentData.ShippingID
              }
            })
          })
          let vm = this
          setTimeout(function(){
            vm.modelValue = false
            vm.searchData();
          }, 20000);
          if(response.data.code=200){
             // this.$alertify.success(response.data.message);
             this.selectedItems = [];
          } else if(response.data.code=202) {
            // this.$alertify.error(response.data.message);
          }else {
                // this.$alertify.error("Internal server Error");
              }
              // this.RMApproveAllRecord=false;
              this.RmApproveLoaderBtn = false
              this.totalSelectedRecords = 0
            }) .catch((httpException) => {
              // this.RMApproveAllRecord=false;
                this.RmApproveLoaderBtn = false
                this.totalSelectedRecords = 0
                  console.error('exception is:::::::::',httpException)
             });
        })

      }
    },

    ApprovePotentialLostShipments(reqObj){
      try {

        let message1 = {
          title: 'Confirm Approval',
          body: `
            <div class="row">
              <div class="col-md-12">
                <p style="font-size:15px; margin-bottom:10px;">
                  You are about to <b style="color:#d9534f;">APPROVE</b> the selected
                  <b>Potential Lost</b> shipments.
                </p>
                <p style="font-size:14px;">
                  This lost will be mark against the current hub.
                </p>
                <p style="color:#d9534f; font-weight:600; font-size:14px;">
                  ⚠ This action cannot be reversed.
                </p>
              </div>
            </div>
          `
        };

        this.$dialog.confirm(message1, {
          html: true,
          animation: 'zoom',
          backdropClose: false,   // Prevent accidental close
          okText: 'Yes, Approve',
          cancelText: 'Cancel',
          loader: true            // Shows loader automatically
        })
        .then(async (dialog) => {
          try {
            dialog.loader = true; // show loading state
            let result = await this.approveShipments(reqObj);  // your API call
            console.log("result", result);
            // this.$alertify.success('Shipments approved successfully.');
            dialog.close();

          } catch (err) {
            dialog.loader = false;
            this.$alertify.error('Something went wrong. Please try again.');
          }
        })
        .catch(() => {
          // Cancel clicked
          // this.$alertify.error('Chose cancel option.');
        });

        return false;
        let message={}
        message = {
          title: '',
          body: ` <div class="row">
                    <div class="col-md-12">
                    <span style="font-size: 15px;">
                      Are you sure you want to <b>APPROVE</b> the selected Potential Lost shipments?
                      This action will mark the Branch Debit as the defaulter and cannot be reversed.
                      </span>
                    </div>
                  </div>`,
        }

        this.$dialog.confirm(message, {
          html: true,
          animation: 'bounce',
          backdropClose: true,
          okText: 'Yes',
          cancelText: 'No',
          reverse: true
          //loader: true
        })
        .then(dialog => {

          this.RmApproveLoaderBtn = true
          let payload=  {
                       "ShipmentLostMasterID": this.selectedItems,
                       "Comments": "Success",
                       "LastModifiedBy":this.localusermailid,
                       "Status": approveType
                   }
        // console.log("PayLoad.........", payload)
        axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/ApproveRejectDebit',payload)
        .then((response) => {

          this.modelValue = true
          this.approvalDebitResultStatus = response.data.data;
          this.approvalDebitResultStatus.forEach((obj) => {
            this.ShipmentData.find(shipmentData => {
              if( shipmentData.ShipmentLostMasterID == obj.ShipmentLostMasterID) {
                obj.shippingIDs = shipmentData.ShippingID
              }
            })
          })
          let vm = this
          setTimeout(function(){
            vm.modelValue = false
            vm.searchData();
          }, 20000);
          if(response.data.code=200){
             // this.$alertify.success(response.data.message);
             this.selectedItems = [];
          } else if(response.data.code=202) {
            // this.$alertify.error(response.data.message);
          }else {
                // this.$alertify.error("Internal server Error");
              }
              // this.RMApproveAllRecord=false;
              this.RmApproveLoaderBtn = false
              this.totalSelectedRecords = 0
            }) .catch((httpException) => {
              // this.RMApproveAllRecord=false;
                this.RmApproveLoaderBtn = false
                this.totalSelectedRecords = 0
                  console.error('exception is:::::::::',httpException)
             });
        })

      } catch(e){
        console.log("Exception in ApprovePotentialLostShipments Fun", e);
      }
    },
    approveShipments(reqObject) {
      return new Promise((resolve, reject) => {
        try {
          // console.log("reqObject ===============>>", reqObject);
          let RaisedebitpayloadARR = [];
          let len = this.selectedItems.length;
          let debitTotal = 0;
          for (let i = 0; i < len; i++) {
            let DebitPersonDetailsP = [];
            let RaiseDebitPayload = {
              "ShippingID": reqObject[i].ShippingID.toString(),
              "HubID": reqObject[i].CurrentHubID,
              "HubName": reqObject[i].HubName,
              "HubLocation": "",
              "ClientID": reqObject[i].ClientID,
              "ClientName": reqObject[i].ClientName,
              "HubZoneID": reqObject[i].HubZoneID,
              "HubZoneName": reqObject[i].HubZoneName,
              "DebitFromType": 'BranchDebit',
              "DebitMode": "",
              "NetPayment": reqObject[i].NetPayment,
              "NetShipmentValue": reqObject[i].NetShipmentValue,
              "DebitAmount": reqObject[i].DebitAmount,
              "OctroiMRP": reqObject[i].OctroiMRP,
              "PenaltyAmount":0,
              "IsGST": true,
              "GSTAmount": 0,
              "TotalDebitAmount": reqObject[i].DebitAmount,
              "Comments": 'Rm approved as Branch Debit',
              "DocketNumber": "",
              "CreatedBy": this.localusermailid,
              "DebitPersonDetails": DebitPersonDetailsP,
              "adjustDebitAmount": 0,
              // "ColoaderID": this.LostShipInfo.Coloader != "" ? this.LostShipInfo.Coloader : undefined,
              // "VehicleVendorID": this.LostShipInfo.Vendor != "" ? this.LostShipInfo.Vendor : undefined,
              // "CourierID": this.LostShipInfo.Courier != "" ? this.LostShipInfo.Courier : undefined,
              "Attachment": "",
              "BankChalanNo": "",
              "olduserid": reqObject[i].CurrentHubID,
              "DebitID":reqObject[i].CurrentHubID,
              "DebitFrom": reqObject[i].HubName,
              "ShipmentType" :reqObject[i].ShipmentType, //need to check in api.
              "Vertical" : reqObject[i].Vertical,
              "CenterType": reqObject[i].CenterType,
              "AOR": reqObject[i].AOR,
              "jobProfile": this.userInfo.jobProfile
            }

            RaiseDebitPayload.LostReason = 'Lost_By_Staff'
            RaiseDebitPayload.SubLostReason = 'Untraceble In Branch'
            RaisedebitpayloadARR.push(RaiseDebitPayload);
          }

          let ShipmentDetails = {RaisedebitpayloadARR}
          // console.log("-=-=-=-=-==========================", ShipmentDetails)

          axios.post(apiUrl.api_url + 'shipmentLost/RMApproveAndRaiseDebit/InsertDebits',ShipmentDetails)
          .then((response) => {
            // console.log("response ============>>", response.data);
            this.modelValue = true;
            this.approvalDebitResultStatus = response.data.data.details;
            this.approvalDebitResultStatus.forEach((obj) => {
              this.ShipmentData.find(shipmentData => {
                if( shipmentData.ShippingID == obj.shipmentId) {
                  obj.shippingIDs = shipmentData.ShippingID
                }
              })
            })
            let vm = this
            setTimeout(function(){
              vm.modelValue = false
              vm.searchData();
            }, 20000);
            if(response.data.data.failed= '0'){
               // this.$alertify.success(response.data.message);
               this.selectedItems = [];
            } else if(response.data.failed != '0') {
              // this.$alertify.error(response.data.message);
            }else {
                  // this.$alertify.error("Internal server Error");
            }
                // this.RMApproveAllRecord=false;
                // this.RmApproveLoaderBtn = false
            this.totalSelectedRecords = 0
            return resolve(true);
          }) .catch((httpException) => {
            // this.RMApproveAllRecord=false;
              this.RmApproveLoaderBtn = false
              this.totalSelectedRecords = 0
              console.error('exception is:::::::::',httpException)
              return resolve(false);
           });
        } catch(e) {
          console.log("Error on RM Submit page", e);
        }
      })
    },
     getShipmentsPopup(shipmentLostMasterID){
       this.attachmentLoader = true
       this.getDebitAmountDataLog = []
       let data={
         ShipmentLostMasterID:shipmentLostMasterID
       }
       axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getDebitDetails',data)
         .then((response) => {
             if(response.data.code=200){
                this.getDebitAmountDataLog = response.data.data;
             }else if (response.data.code=204) {
               this.getDebitAmountDataLog = [];
             }else if (response.data.code=202) {
               this.getDebitAmountDataLog = [];
             }else {
               this.getDebitAmountDataLog = [];
             }
             this.attachmentLoader = false;
           })
         .catch((httpException) => {
           this.attachmentLoader = false;
             console.error('exception is:::::::::',httpException)
         });
       this.getShipmentsflag= true;
       this.getShipmentslog();
     },

     getDebitAmountPopup(shipmentLostID){
       this.getDebitAmountflag= true;
       this.getDebitAmountData = []
       let data={
         ShipmentLostMasterID:shipmentLostID
       }
       this.attachmentLoader = true
       axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getDebitDetails',data)
         .then((response) => {
             if(response.data.code=200){
                this.getDebitAmountData = response.data.data;

             }else if (response.data.code=204) {
               this.getDebitAmountData = [];
             }else if (response.data.code=202) {
               this.getDebitAmountData = [];
             }else {
               this.getDebitAmountData = [];
             }
             this.attachmentLoader = false
           })
         .catch((httpException) => {
           this.attachmentLoader = false
             console.error('exception is:::::::::',httpException)
         });
     },
     getShipmentAttachmentPopup(val){
       this.attachmentLoader = true
       this.getAttachmentFlag= true
      //  console.log(val.sourcetype.toLowerCase());
      if(val.sourcetype){
        var imgTrack=val.sourcetype.toLowerCase()=="investigationlost"? val.sourcetype.toLowerCase():"other";
      }else{
        imgTrack="other";
      }
       let data={
         ShippingID: val,
         getImageTrackFrom:imgTrack,
       }
       axios.post(apiUrl.api_url + 'Lost/ShippindID/AttachmentDownload',data)
         .then((response) => {
          console.log("Images", response);
             if(response.data.code == 200){
                this.getAttachmentListData = response.data.data.lostImages;
                this.getInvestigationImgs = response.data.data.investigationImages
                console.log("Images", this.getAttachmentListData, this.getInvestigationImgs);
                if(this.getAttachmentListData.length !=0){
                  this.getAttachmentListData.forEach(ele=>{
                    // const extension = ele.filePath.split('.').pop().toLowerCase();
                    const extension = this.getFileExtension(ele.filePath);
                    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff'];
                    const videoExtensions = ['mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv', 'webm', 'ogg'];
                    const pdfExtensions = ['pdf', 'docx'];

                    // Determine the file type based on the extension
                    if (imageExtensions.includes(extension)) {
                        ele.fileType='image'
                    } else if (videoExtensions.includes(extension)) {
                        ele.fileType='video'
                    } else if (pdfExtensions.includes(extension)) {
                       ele.fileType='pdf'
                    }
                  })
                }

                if(this.getInvestigationImgs.length!=0){
                  console.log(this.getInvestigationImgs);

                  this.getInvestigationImgs.forEach(ele=>{
                    // const extension = ele.fileName.split('.').pop().toLowerCase();
                    const extension = this.getFileExtension(ele.filePath);
                    console.log(extension,">>>>>>>");
                    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff'];
                    const videoExtensions = ['mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv', 'webm', 'ogg'];
                    const pdfExtensions = ['pdf', 'docx'];

                    // Determine the file type based on the extension
                    if (imageExtensions.includes(extension)) {
                        ele.fileType='image'
                    } else if (videoExtensions.includes(extension)) {
                        ele.fileType='video'
                    } else if (pdfExtensions.includes(extension)) {
                       ele.fileType='pdf'
                    }
                  })
                }
                // console.log("dgjdjdh",this.getAttachmentListData)
             } else if(response.data.code == 202) {
               this.getAttachmentListData = [];
               this.getInvestigationImgs=[];
               this.$alertify.error(response.data.message);
             }
             this.attachmentLoader = false;
           })
         .catch((httpException) => {
              this.attachmentLoader = false;
             console.error('exception is:::::::::',httpException)
         });
     },
     closeAttachmentPopup(){
      this.getAttachmentFlag = false
     },
     getShipmentslog(ShippingID){
       this.getShipmentsSummeryData=[];
       axios.get(apiUrl.api_url + `external/getshipmentlog?ShippingID=${ShippingID}`)
         .then((response) => {
             this.shipmentlogmodal = true;
             if(response.data.code===200){
                 this.getShipmentslogData = response.data.data;
                 this.getShipmentsflag = true;
                 this.getShippingIdforLog = ShippingID;
             }
             else {
                 this.shipmentLogList = [];
             }
         })
         .catch((httpException) => {
               this.$alertify.success("Shpment Log data not found");
               console.error('exception is:::::::::', httpException)
         })
     },
     getShipmentsSummery(){
       this.getShipmentslogData=[];
       this.getShipmentsSummeryData=[];
     },
     getImage(){
       // console.log("inside get image");
     },
     closeonPopup() {
       this.getShipmentslogData=[]
       this.getShipmentslogData=[];
       this.getDebitAmountData=[];
       this.raiseRMDebitNoteData=[];
       this.amount=0;
       this.raiseRMDebitNoteEditflag = false;
       this.getShipmentsflag= false;
       this.getDebitAmountflag= false;
       this.raiseRMDebitNotecomment='';
       this.DebitShareinRs=[];
       this.Percentage='';
       this.selectEditItemsList = [];
       this.$validator.reset();
       this.errors.clear();
     },
     calculateDebitAmout(DebitAmount,percentVal = 100,userid=''){
       if(this.selectEditItemsList.length > 0){
         this.isDebitPersonSelected = this.selectEditItemsList.length;
         if(userid != '' && document.getElementById(userid).checked == false){

           this.debitPersonPercent[userid] = "";
           this.debitPersonAmount[userid] = "";
         }
         let selectDebitUsercount = this.selectEditItemsList.length;

         let percentage = 0;
         let amount = 0 ;
         if(DebitAmount == '' || DebitAmount == 0 || DebitAmount == 'undefined'){
             percentage = 0;
             amount = 0;
         }else{
            percentage = (parseFloat(percentVal) / parseFloat(selectDebitUsercount)).toFixed(2);
            amount = (parseFloat(DebitAmount) / parseFloat(selectDebitUsercount)).toFixed(2);
         }

         let raiseDebitAmount = 0;

         for(let i = 0; i<selectDebitUsercount ; i++){
           raiseDebitAmount = parseFloat(raiseDebitAmount) + parseFloat(amount);
           this.debitPersonPercent[this.selectEditItemsList[i]] = percentage;
           this.debitPersonAmount[this.selectEditItemsList[i]] = amount;
         }
         this.adjustDebitAmount = (parseFloat(DebitAmount) - parseFloat(raiseDebitAmount)).toFixed(2);
       }else{
         this.isDebitPersonSelected ="";
         this.debitPersonPercent[userid] = "";
         this.debitPersonAmount[userid] = "";
       }

     },
     adjustDebitPercenatge(getUserId){
       let getdebitshareAmount = this.debitPersonAmount[getUserId];
       let getpercentage = this.debitPersonPercent[getUserId];
       let DebitAmount = this.amount;
       let percentage = 0;

       if(getdebitshareAmount != ''){
         if(parseFloat(getdebitshareAmount) > parseFloat(DebitAmount)){
             document.getElementById('debitshare'+getUserId).classList.add("validate-error");
             this.$alertify.error("Entered amount should not be greater than debit amount");
             document.getElementById('debitshare'+getUserId).focus();
             this.isAPICallFlag = false;
         }else{
           let selectedUser = this.selectEditItemsList.length;
             for(let i = 0; i<selectedUser ; i++){
               document.getElementById('debitshare'+this.selectEditItemsList[i]).classList.remove("validate-error");
               document.getElementById('percentage'+this.selectEditItemsList[i]).classList.remove("validate-error");
             }
           this.isAPICallFlag = true;
         }
         percentage = ((parseFloat(getdebitshareAmount) / parseFloat(DebitAmount)) * 100).toFixed(2);
         this.debitPersonPercent[getUserId] = percentage;
       } else{
         this.isAPICallFlag = false;
         this.debitPersonAmount[getUserId] = 0;
         this.debitPersonPercent[getUserId] = 0;
         let filteredAry = this.selectedItems.filter(function(e) { return e !== getUserId });
         this.selectedItems = filteredAry;
         getdebitshareAmount = 0;
         //this.$alertify.error("false");
       }
       let totaleDebitAmount = parseFloat(DebitAmount) - parseFloat(getdebitshareAmount);
       let totaleDebitPercent = (parseFloat(100) - parseFloat(percentage)).toFixed(2);

       let filteredAry = this.selectEditItemsList.filter(function(e) {
         return e != getUserId
      });

       let getNewUpdatepercent = this.debitPersonPercent[getUserId];
       this.selectEditItemsList = filteredAry;
       this.calculateDebitAmout(totaleDebitAmount,totaleDebitPercent);
       if(getdebitshareAmount != 0){
         var isExistuserid = this.selectEditItemsList.includes(Number(getUserId));
         if(!isExistuserid){
           this.selectEditItemsList.splice(0, '', Number(getUserId));
         }
       }

       if(this.selectEditItemsList.length>0){
         this.isDebitPersonSelected = this.selectedItems.length;
       }else{
         this.isDebitPersonSelected = "";
       }
     },
     adjustDebitAmout(getUserId){
       let getpercentage = this.debitPersonPercent[getUserId];
       let DebitAmount = this.amount;

       if(getpercentage !=''){
         if(getpercentage > 100){
             document.getElementById('percentage'+getUserId).classList.add("validate-error");
             this.$alertify.error("Entered percent should not be greater than 100%");
             document.getElementById('percentage'+getUserId).focus();
             this.isAPICallFlag = false;
         }else{
           let selectedUser = this.selectEditItemsList.length;
           for(let i = 0; i<selectedUser; i++){
             document.getElementById('debitshare'+this.selectEditItemsList[i]).classList.remove("validate-error");
             document.getElementById('percentage'+this.selectEditItemsList[i]).classList.remove("validate-error");
           }
           this.isAPICallFlag = true;
         }
         let TotAmount = ((parseFloat(DebitAmount) / parseFloat(100)) * parseFloat(getpercentage) ).toFixed(2);
         this.debitPersonAmount[getUserId] = TotAmount;
       }else{
         this.isAPICallFlag = false;
         this.debitPersonAmount[getUserId] = 0;
         this.debitPersonPercent[getUserId] = 0;
         let filteredAry = this.selectedItems.filter(function(e) { return e !== getUserId });
         this.selectedItems = filteredAry;
         getpercentage = 0;
         //this.$alertify.error("false");
       }

       let getdebitshareAmount = this.debitPersonAmount[getUserId];
       let totaleDebitAmount = parseFloat(DebitAmount) - parseFloat(getdebitshareAmount);
       let totaleDebitPercent = (parseFloat(100) - parseFloat(getpercentage)).toFixed(2);
       let filteredAry = this.selectEditItemsList.filter(function(e) { return e != getUserId });

       this.selectEditItemsList = filteredAry;
       this.calculateDebitAmout(totaleDebitAmount,totaleDebitPercent);
       if(getpercentage !=''){
         var isExistuserid = this.selectEditItemsList.includes(Number(getUserId));
         if(!isExistuserid){
           this.selectEditItemsList.splice(0, " ", Number(getUserId));
         }
       }
       if(this.selectEditItemsList.length>0){
         this.isDebitPersonSelected = this.selectedItems.length;
       }else{
         this.isDebitPersonSelected = "";
       }
     },
     calculateTotalEnteredAmt(){
         let len = this.selectEditItemsList.length;
         let debitTotal = 0;
         for(let i = 0; i<len ; i++){
           let debitshare = this.debitPersonAmount[this.selectEditItemsList[i]];
           debitTotal = parseFloat(debitTotal) + parseFloat(debitshare);
         }
         //debitTotal = parseFloat(debitTotal) + parseFloat(this.adjustDebitAmount);
         if(parseFloat(debitTotal).toFixed(1) === parseFloat(this.amount).toFixed(1)){
           this.isAPICallFlag = true;
         } else {
           this.$alertify.error("Debit amount not matched");
           this.isAPICallFlag = false;
         }
     },
     getPaginationData(pageNum) {
       this.pageno = pageNum;
       this.selectedItems = []
       this.totalSelectedRecords = 0
       this.selectAllItems = false
       this.SearchShipmets();
     },
///THIS CSV DOWNLOAD START
downloadCsv() {
  if(this.toDate >= this.fromDate ){

    this.ExportRmApproveLoaderBtn = true;
    let hubIDarray = []
    if(this.hubID.length > 0 ){
      this.hubID.map(hub=>{
        hubIDarray.push(hub.HubID)
      })
    }else{
      if(this.filteredHubList.length > 0){
        this.filteredHubList.map(hub=>{
          hubIDarray.push(hub.HubID)
        })
      }else{
        this.Loading = false;
        this.ExportRmApproveLoaderBtn = false;
        this.ShipmentData=[];
        this.totalRecords=0;
        this.pagecount = 0;
        this.$alertify.error("No SVC found for selected filter's..!")
        return false;
      }

    }
    if (this.ShipmentType =="All"){
      this.ShipmentType = ""
    }
    let data={
        fromDate:this.fromDate ,
        toDate: this.toDate,
        HubZoneID: this.hubzoneid,
        DebitFromType: this.debitFrom,
        HubId: hubIDarray,
        Vertical: this.Vertical,
        CenterType: this.CenterType,
        offset : this.pageno - 1,
        limit : 100,
        ShippingID:this.awbnumbers,
        isCsvDownload: false,
        ShipmentType : this.ShipmentType
    };
    if (this.awbnumbers.length>0) {
      let shippingId=this.awbnumbers.split(/[\s,]+/);
      let shipmentReqArray = [];
      $.each(shippingId, (key,shipmentId)=>{
        if(shipmentId != ''){
          shipmentReqArray.push(shipmentId.trim())
        }
        if(shipmentReqArray.length > 100){
          this.$alertify.error("Maximum 100 shippingID you can enter.")
        }else{
          data.ShippingID = shipmentReqArray;
        }
      })
    }
    let vm = this;
    axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getShipmentList',data)
    // axios.post('http://localhost:3800/shipmentLost/RMApproval/getShipmentList',data)
      .then((response) => {
        if(response.data.code == 200){
          let data1={
            "hubDetailes":response.data.data
          }
           // axios.post(apiUrl.api_url + 'external/EmpDetails/List',data1)
           //   .then((response1) => {
               //this.ShipmentData = response1.data.data;
               const commonData = [

                ['Shipping ID','Client Name','Zone','Hub Name','Status','Debit From',
                  'Total Shipment Value','Penalty','Debit Amount','Debit Concern Person','Docket No','Debit Date',
                  'Lastmodified Date','Created By', 'Comments'
                ],
                [],
              ];
               let csvArrayExportObj = [];

              //  response1.data.data.forEach(function(item){

              //    let debitNames = item['shipmentlostdebitdetails'].map(function(childItem) {
              //       return childItem['DebitFrom'];
              //     });
              //    csvArrayExportObj.push({
              //      "Shipping ID": item.ShippingID,
              //      "Client Name": item.ClientName,
              //      "Zone": item.HubZoneName,
              //      "Hub Name" : item.HubName,
              //      "Status":item.Status,
              //      "Debit From" : item.DebitFromType,
              //      "Total Shipment Value": item.NetShipmentValue,
              //      "Penalty" : item.Penalty?item.Penalty:0,
              //      "Debit Amount" : item.DebitAmount?item.DebitAmount:0,
              //      "Debit Concern Person" : debitNames.join('  -  '),
              //      "Docket No" : item.DocketNumber,
              //      "Debit Date" : item.CreatedDate,
              //      "Lastmodified Date" : item.LastModifiedDate,
              //      "Created By" : item.CreatedBy,
              //      "Comments" : item.Comments,

              //      }
              //    )
              //  });

              response.data.data.forEach(function(item){
                let debitNames = []
                let debitdetails = item.shipmentlostdebitdetails
                // console.log("debitdetails ======>>", debitdetails);
                if(debitdetails) {
                  debitNames = debitdetails.map(function(childItem) {
                     return childItem['DebitFrom'] && childItem['DebitFromType']=='RSC'?
                                childItem['DebitFrom'].replace(/[\n\s]/g, ''):
                                childItem['DebitFrom']
                   });
                }
                // console.log("debitNames ===============>>>>>>", debitNames);
                const gethub = vm.hubAccessList.find(hub => hub.HubID === item.CurrentHubID);
                const getzone = item.HubZoneID ? vm.hubAccessList.find(zone => zone.HubZoneId == item.HubZoneID) : 'undefined';

                item.HubName = gethub && gethub.HubID ? gethub.HubName : item.HubName
                item.HubZoneName = getzone && getzone.HubZoneId ? getzone.hubzonename : item.HubZoneName
                let debitgreatureamount = parseFloat(item.NetPayment) > parseFloat(item.OctroiMRP) ? item.NetPayment : item.OctroiMRP
                item.NetShipmentValue = debitgreatureamount;
                item.DebitAmount = item.ispotentiallost && !item.ShipmentLostMasterID ?  debitgreatureamount : item.DebitAmount
                item.CreatedDate = item.ispotentiallost && !item.ShipmentLostMasterID ?  '-' : item.CreatedDate

                 let rsltDebitNames = debitNames.length>1 ? debitNames.map((item, index) => `${index + 1}) ${item}`).join('  '):debitNames[0];
                csvArrayExportObj.push([
                   item.ShippingID?item.ShippingID:'-',
                   item.ClientName?item.ClientName:'-',
                   item.HubZoneName?item.HubZoneName:'-',
                   item.HubName?item.HubName:'-',
                   item.Status?item.Status:'-',
                   item.DebitFromType?item.DebitFromType:'-',
                   item.NetShipmentValue?item.NetShipmentValue:0,
                   item.Penalty?item.Penalty:0,
                   item.DebitAmount?item.DebitAmount:0,
                   rsltDebitNames,
                   item.DocketNumber?item.DocketNumber:'-',
                   item.CreatedDate?item.CreatedDate:'-',
                   item.LastModifiedDate?item.LastModifiedDate:'-',
                   item.CreatedBy?item.CreatedBy:'-',
                   item.Comments?item.Comments.replace(/[,\n]/g, ''):'-',

                ]
                )
              });
               this.ExportRmApproveLoaderBtn = false;
               this.exportCsv(csvArrayExportObj, commonData);
           //   })
           // .catch((httpException) => {
           //     console.error('exception is:::::::::',httpException)
           // });
        }else if(response.data.code == 204) {
          this.ExportRmApproveLoaderBtn = false;
          this.ShipmentData = [];
          this.$alertify.error("No Pending Approval");
        }else if(ExportRmApproveLoaderBtn.data.code == 202) {
          this.Loading = false;
          this.ShipmentData = [];
          this.$alertify.error(response.data.message);
        }else{
          this.ExportRmApproveLoaderBtn = false;
          this.ShipmentData = [];
          this.$alertify.error(response.data.message);
        }
      })
    .catch((httpException) => {
        console.error('exception is:::::::::',httpException)
    });
  }
  else {
    this.$alertify.error("To Date is greter than from Date");
  }
},
exportCsv(shipmentObjectdata, commonData=null) {
  let csvContent = "data:text/csv;charset=utf-8,";
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();
  var today = dd + "" + mm + "" + yyyy;
  let filename = "RMApproveDebit" + today + ".csv";
  commonData ? csvContent +=
        commonData.map(row => row.join(',')).join('\n') :null;


        csvContent +=
        shipmentObjectdata.map(row => row.join(',')).join('\n');
  // csvContent += [
  //   Object.keys(shipmentObjectdata[0]).join(";"),
  //   ...shipmentObjectdata.map(item => Object.values(item).join(";"))
  // ]
  // .join("\n")
  // .replace(/(^\[)|(\]$)/gm, "");

  const data = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", data);
  link.setAttribute("download", filename);
  link.click();
},


selectItems(ev) {
  this.selectedItems = [];
  this.selectedItemsdetails=[];
  if (ev.target.checked == true) {
      for (let i in this.ShipmentData) {
        this.selectedItems.push(this.ShipmentData[i].ShippingID.toString());
        this.selectedItemsdetails.push(this.ShipmentData[i]);
      }
      let found = this.selectedItemsdetails.some(obj => obj.DebitFromType === "BranchDebit");
      if(found){
        this.isFacility=true;
      }
      this.selectedItemsdetails.forEach(element => {
        this.totalDebitAmount=parseFloat(this.totalDebitAmount)+parseFloat(element.DebitAmount)
        this.totalDebitAmount=this.totalDebitAmount.toFixed(2)
      });
      this.checkIsPotentialLostShipmentExist(this.selectedItems);
  }else{
    this.isFacility=false;
    this.totalDebitAmount=0;
  }

  this.totalSelectedRecords = this.selectedItems.length
  console.log(this.totalSelectedRecords,"<<<<<<<<<<<<<<");

  //this.calculateDebitAmout(this.amount,100);
},

// selectItems(ev) {
//   this.selectedItems = [];
//   this.selectedItemsdetails=[];
//   if (ev.target.checked == true) {
//       for (let i in this.ShipmentData) {
//         this.selectedItems.push(this.ShipmentData[i].ShipmentLostMasterID.toString());
//         this.selectedItemsdetails.push(this.ShipmentData[i]);
//       }
//   }
//   let found = this.selectedItemsdetails.some(obj => obj.DebitFromType === "BranchDebit");
//   const count = this.selectedItemsdetails.filter(obj => obj.DebitFromType === "BranchDebit").length;
//   if (found) {
//     if(count!=this.selectedItems.length){
//         this.isApprove=false;
//         this.isFacility=false;
//         this.RMApproveAllRecord=false;
//         this.facilityArr=[];
//         this.selectedItems=[];
//         this.uncheckAll()
//       this.$alertify.error("Please select only BranchDebit / courier,servicecenter");
//     }else{
//       this.isFacility=true;
//       this.isApprove=true;
//     }
//   } else {
//      this.isApprove=true;
//   }
//   this.totalSelectedRecords = this.selectedItems.length
//   //this.calculateDebitAmout(this.amount,100);
// },
  selectItemsonPopup(ev) {
      this.selectEditItemsList = [];
      if (ev.target.checked == true) {
          for (let i in this.raiseRMDebitNoteData) {

            if(this.raiseRMDebitNoteData[i].DebitFromType === "Vendor" || this.raiseRMDebitNoteData[i].DebitFromType === "NetworkVendor"){
              this.selectEditItemsList.push(this.raiseRMDebitNoteData[i].VehicleVendorID);

            } else if(this.raiseRMDebitNoteData[i].DebitFromType === "ServiceCenter"){
              this.selectEditItemsList.push(this.raiseRMDebitNoteData[i].UserID);
            } else if(this.raiseRMDebitNoteData[i].DebitFromType === "Coloader"){
              this.selectEditItemsList.push(this.raiseRMDebitNoteData[i].ColoaderID);
            } else if(this.raiseRMDebitNoteData[i].DebitFromType === "Courier"){
              this.selectEditItemsList.push(this.raiseRMDebitNoteData[i].CourierID);
            }
          }
      }else{
        for (let i in this.raiseRMDebitNoteData) {
          if(this.raiseRMDebitNoteData[i].DebitFromType === "Vendor" || this.raiseRMDebitNoteData[i].DebitFromType === "NetworkVendor"){
            this.debitPersonPercent[this.raiseRMDebitNoteData[i].VehicleVendorID] = "";
            this.debitPersonAmount[this.raiseRMDebitNoteData[i].VehicleVendorID] = "";

          }else if(this.raiseRMDebitNoteData[i].DebitFromType === "ServiceCenter"){
            this.debitPersonPercent[this.raiseRMDebitNoteData[i].UserID] = "";
            this.debitPersonAmount[this.raiseRMDebitNoteData[i].UserID] = "";

          }else if(this.raiseRMDebitNoteData[i].DebitFromType === "Coloader"){
            this.debitPersonPercent[this.raiseRMDebitNoteData[i].ColoaderID] = "";
            this.debitPersonAmount[this.raiseRMDebitNoteData[i].ColoaderID] = "";
          }else if(this.raiseRMDebitNoteData[i].DebitFromType === "Courier"){
            this.debitPersonPercent[this.raiseRMDebitNoteData[i].CourierID] = "";
            this.debitPersonAmount[this.raiseRMDebitNoteData[i].CourierID] = "";
          }else if(this.raiseRMDebitNoteData[i].DebitFromType === "Store" || this.raiseRMDebitNoteData[i].DebitFromType === "RSC" ||
            this.raiseRMDebitNoteData[i].DebitFromType === "BranchDebit"
          ){
            this.debitPersonPercent[this.raiseRMDebitNoteData[i].DebitID] = "";
            this.debitPersonAmount[this.raiseRMDebitNoteData[i].DebitID] = "";
          }

        }
        this.selectEditItemsList = [];
      }
      this.calculateDebitAmout(this.amount,100);
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result){
          this.calculateTotalEnteredAmt();
          if(this.isAPICallFlag == true){
             //this.raiseRMDebitNoteEditflag = false;
             let debitConcernsDetails = [];
             let usercount = this.selectEditItemsList.length;
             for (let i = 0; i< usercount; i++) {

               let debitShareAmount = this.debitPersonAmount[this.selectEditItemsList[i]];
               let debitpercentage = this.debitPersonPercent[this.selectEditItemsList[i]];
               let getShipmentLostDetailsId =  this.getShipmentLostDetailsID[this.selectEditItemsList[i]];

               debitConcernsDetails.push({
                 "ShipmentLostDetailsID" : getShipmentLostDetailsId,
                 "DebitAmount": debitShareAmount,
                 "DebitPercentage": debitpercentage
               });
             }
             let RaiseDebitPayload = [{
               "ShipmentLostMasterID" :this.getShipmentLostMasterID,
               "DebitPersonDetails" : debitConcernsDetails,
               "Comments":this.raiseRMDebitNotecomment,
               "LastModifiedBy" : this.localusermailid
             }]
             axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/approveDebit', RaiseDebitPayload)
              .then((response) => {
                  this.modelValue = true
                  this.approvalDebitResultStatus = response.data.data;
                  this.approvalDebitResultStatus.forEach((obj) => {
                    this.ShipmentData.find(shipmentData => {
                      if( shipmentData.ShipmentLostMasterID == obj.ShipmentLostDetailsID) {
                        obj.shippingIDs = shipmentData.ShippingID
                      }
                    })
                  })
                  let vm = this
                  setTimeout(function(){
                    vm.modelValue = false
                    vm.searchData();
                  }, 20000);
                   if(response.data.code === 200){
                       // this.$alertify.success("Approve debit successful");
                       this.searchData();
                       this.raiseRMDebitNoteEditflag= false;
                       this.totalSelectedRecords = 0
                   }
                   else if(response.data.code === 202){
                       // this.$alertify.error("Already Approved debit");
                       this.raiseRMDebitNoteEditflag= false;
                       this.totalSelectedRecords = 0
                   }else{
                     this.$alertify.error(response.data.message);
                   }
               })
               .catch((httpException) => {
                     this.$alertify.success("Failed to approve debit");
                     console.error('exception is:::::::::', httpException)
               })
             this.selectEditItemsList = [];
             this.raiseRMDebitNoteEditflag = false;
          }
       }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });

    },
    clear(){
      this.getServiceCentreList("");
      this.ShipmentType = '';
      this.awbnumbers = '';
      this.Vertical = '';
      this.CenterType = ''
      this.totalSelectedRecords = 0
      this.totalDebitAmount=0;
      this.addDebitAmt=0;
      this.raiseRMDebitNoteData=[];
      // this.RMApproveAllRecord = '';
      this.fromDate = '';
      this.toDate = '';
      this.hubname='';
      this.hubzoneid='';
      this.debitFrom='';
      this.searchflag=false;
      this.ShippingId='';
      this.raiseRMDebitNotecomment='';
      this.DebitShareinRs='';
      this.Percentage='';
      this.hubID='';
      this.CenterType = '';
      this.pageno = 1;
      this.$refs.paginate.selected= 0;
      this.pagecount = 0;
      this.selectedItems = [];
      this.selectedItemsdetails=[];
      this.errors.clear();
      this.hubList = [];
      this.hubStateId = ''
      this.hubCitybyStateList = [],
      this.hubCityId = ''
      this.AOR = '';
      this.selectedHubZoneId = '';
      this.selectedStateId = '';
      this.selectedCityId = '';
      this.selectedAOR = '',
      this.selectedCenterType = '',
      this.filteredHubList = [],
      // this.filterHubList(),
      // this.modelValue = false
      this.usernames = ''
      this.source = ''
    },
    closeApprovalResultModel() {
      this.modelValue =false
      this.selectedItems=[];
      this.totalDebitAmount=0;
      this.addDebitAmt=0;
      this.shipmentDetails=[];
    },
    onApproveClear() {
      this.selectedItems = [];
      this.totalSelectedRecords = 0
      this.totalDebitAmount=0;
      this.addDebitAmt=0;
    },
    async getServiceCentreList(selectedCentreType) {
      this.selectedCenterType = selectedCentreType
      let getMasterHubListDetails = await this.getMasterHubList();
      if ( selectedCentreType ) {
        this.filterHubList()
      }
    },
    getHubStateList(){
    //   axios.get(apiUrl.api_url + 'external/stateList')
    //   .then((response) => {
    //     this.hubStateList = response.data.data;
    //   })
    // .catch((httpException) => {
    //     console.error('exception is:::::::::',httpException)
    // });

      /**
       Details get based on the login user has hubaccess.
      */
      let stateHub=[]
      this.hubAccessList.filter(element=>{
        const existingIndex = stateHub.findIndex(item => item.HubStateId === element.HubStateId);
            if (existingIndex != -1) {
              stateHub[existingIndex] = element;
          } else {
               stateHub.push(element);
          }
      });
      this.hubStateList=stateHub;
      // console.log("=====,,,,,,,", this.hubStateList)
    },

    getCitiesbyState(event){
    //   this.selectedStateId = event.target.value
    //   this.filterHubList()
    // let data={
    //   stateID:[event.target.value]
    // }
    // axios.post(apiUrl.api_url + 'external/citiesByState',data)
    //   .then((response) => {
    //     this.hubCitybyStateList = response.data.data;
    //   })
    // .catch((httpException) => {
    //     console.error('exception is:::::::::',httpException)
    // });

      this.selectedStateId = event.target.value;
      this.hubID=[];
      this.hubCityId='';
      this.filterHubList()
      const filtered=this.hubAccessList.filter(element=>(element.HubStateId===parseInt(event.target.value)));
      var cityHub=[]
      filtered.filter(element=>{
        const existingIndex = cityHub.findIndex(item => item.CityId === element.CityId);
            if (existingIndex != -1) {
              cityHub[existingIndex] = element;
          } else {

            cityHub.push(element);
          }
      });
      this.hubCitybyStateList=cityHub;
  },

  getAORList(){
    axios.get(apiUrl.api_url + 'external/AORList')
      .then((response) => {
        this.AORList = response.data.data;
      })
    .catch((httpException) => {
        console.error('exception is:::::::::',httpException)
    });
  },

  getHubsByCities(event){
    this.selectedCityId = event.target.value
    this.hubID=[];
    this.filterHubList()
  },

  getHubsByAOR(AOR){
    this.selectedAOR = AOR
    // this.hubID=[];
    this.filterHubList()
  },

  getHubsByZoneId(event){
    this.selectedHubZoneId = event.target.value
    this.hubID=[];
    this.hubStateId='';
    this.hubCityId='';
    this.AOR='';
    this.CenterType='';
    this.selectedStateId = '';
    this.selectedCityId = '';
    this.selectedAOR = '';
    this.selectedCenterType = '';
    this.filterHubList()
  },

  // filterHubList() {
  //   this.isLoading = true;
  //   this.filteredHubList=this.allhubList;
  //   var allhub=this.allhubList
  //   var result=[];
  //     if(this.selectedHubZoneId!=''){
  //        result=allhub.filter(h =>
  //               h.HubZoneId==this.selectedHubZoneId
  //             )
  //     }
  //     if(this.selectedHubZoneId!='' && this.selectedStateId!=''){
  //       result=allhub.filter(h =>
  //         h.HubZoneId==this.selectedHubZoneId &&
  //         h.HubStateId==this.selectedStateId
  //       )
  //     }
  //     if(this.selectedHubZoneId!='' && this.selectedStateId!='' && this.selectedCityId){
  //       result=allhub.filter(h =>
  //         h.HubZoneId==this.selectedHubZoneId &&
  //         h.HubStateId==this.selectedStateId &&
  //         h.CityId==this.selectedCityId
  //       )
  //     }
  //     if(this.selectedHubZoneId!='' && this.selectedStateId!='' &&
  //       this.selectedCityId !=''&& this.selectedAOR != ''){
  //       result=allhub.filter(h =>
  //         h.HubZoneId==this.selectedHubZoneId &&
  //         h.HubStateId==this.selectedStateId &&
  //         h.CityId==this.selectedCityId &&
  //         h.soc && h.soc.toLowerCase().trim()===this.selectedAOR.toLowerCase().trim()
  //       )
  //     }
  //     if(this.selectedHubZoneId!='' && this.selectedStateId!='' &&
  //       this.selectedCityId !=''&& this.selectedAOR != '' && this.selectedCenterType != ''){
  //       result=allhub.filter(h =>
  //       h.HubZoneId==this.selectedHubZoneId &&
  //       h.HubStateId==this.selectedStateId &&
  //       h.CityId==this.selectedCityId &&
  //       h.soc &&  h.soc===this.selectedAOR &&
  //       h.CenterType && h.CenterType===this.selectedCenterType
  //     )
  //     }
  //     if(this.selectedAOR != ''){
  //       result=allhub.filter(h =>
  //         h.soc && h.soc.toLowerCase().trim() === this.selectedAOR.toLowerCase().trim()
  //       )
  //    }
  //    if(this.selectedCenterType != ''){
  //     result=allhub.filter(h =>
  //       h.CenterType && h.CenterType.toLowerCase().trim() === this.selectedCenterType.toLowerCase().trim()
  //     )
  //   }
  //   if(this.selectedAOR != '' && this.selectedCenterType != ''){
  //     result=allhub.filter(h =>
  //       h.soc && h.soc.toLowerCase().trim() === this.selectedAOR.toLowerCase().trim() &&
  //       h.CenterType && h.CenterType.toLowerCase().trim() === this.selectedCenterType.toLowerCase().trim()
  //     )
  //   }
  //   this.filteredHubList=result;
  //   this.isLoading = false;
  // },

  filterHubList() {
    this.isLoading = true;
    let result = this.allhubList;

    // Build a dynamic filter based on selected values
    const filters = [];

    // Add filter for HubZoneId if selected
    if (this.selectedHubZoneId) {
        filters.push(h => h.HubZoneId && h.HubZoneId == this.selectedHubZoneId);
    }

    // Add filter for HubStateId if selected
    if (this.selectedStateId) {
        filters.push(h => h.HubStateId && h.HubStateId == this.selectedStateId);
    }

    // Add filter for CityId if selected
    if (this.selectedCityId) {
        filters.push(h => h.CityId && h.CityId == this.selectedCityId);
    }

    // Add filter for AOR (soc) if selected
    if (this.selectedAOR) {
        filters.push(h => h.soc && h.soc.toLowerCase() === this.selectedAOR.toLowerCase());
    }

    // Add filter for CenterType if selected
    if (this.selectedCenterType) {
        filters.push(h => h.CenterType && h.CenterType.toLowerCase() === this.selectedCenterType.toLowerCase());
    }

    // Apply all filters
    result = result.filter(hub => filters.every(filter => filter(hub)));
    if(result.length==0){
      this.$alertify.error("No service center hubs found..!!");
    }

    // Set the filtered hub list
    this.filteredHubList = result;
    this.isLoading = false;
},

  getMasterHubList() {
    return new Promise((resolve,reject) => {
      try {
        this.isLoading = true;
      let data = {
        centerType : []
      }
        axios.post(apiUrl.api_url + 'external/filterHubDetails', data)
          .then((response) => {
            // this.masterHubList = response.data.data;
            let allHubdata = response.data.data;
            let filteredHubList = allHubdata.filter(o => this.hubAccessList.some(({HubID}) => o.HubID === HubID));
            let mergedArray = this.hubAccessList.map(obj1 => {
              let obj2 = filteredHubList.find(obj => obj.HubID === obj1.HubID);
              return Object.assign({}, obj1, obj2);
          });
            this.filteredHubList=mergedArray
            this.allhubList=this.filteredHubList;
            console.log("this.filteredHubList",this.allhubList)
            this.isLoading = false;
            resolve(this.allhubList)
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
            resolve([])
            this.isLoading = false;
          });
      } catch(e) {
        console.log('Error', e);
        resolve([])
        this.isLoading = false;
      }
    })
  },
  showDebitFromModal(shippingId){
    this.debitFromModal = true
    let debitDetails = this.ShipmentData.filter(x => x.ShippingID == shippingId)
    this.debitDetailsFull = [];
    debitDetails[0].shipmentlostdebitdetails.forEach((item, i) => {

      let uniqueSRs = [];
      if ( debitDetails[0].DebitPersonalDetails && debitDetails[0].DebitPersonalDetails.length > 0) {
        uniqueSRs = debitDetails[0].DebitPersonalDetails.filter(y => y.ShipmentLostDetailsID == item.ShipmentLostDetailsID)
      }

      if ( uniqueSRs.length ) {
        for (var valueobj of uniqueSRs) {
          let debitPerson = {}
          debitPerson.ShippingID = item.ShippingID
          debitPerson.DebitFromType = item.DebitFromType
          debitPerson.DebitFrom = valueobj.SRName
          debitPerson.VendorNameAndID = `${item.AgencyName} ( ${item.SRAgencyID})`
          debitPerson.DebitID = item.DebitID
          debitPerson.DeliveryUserID = valueobj.UserID
          debitPerson.DebitAmount = valueobj.DebitAmount

          this.debitDetailsFull.push(debitPerson);
        }
      } else {
        let debitDetailsP = {}
        debitDetailsP.ShippingID = item.ShippingID
        debitDetailsP.DebitFromType = item.DebitFromType
        debitDetailsP.DebitFrom = item.DebitFrom
        debitDetailsP.DebitAmount = item.DebitAmount
        debitDetailsP.DeliveryUserID = item.DeliveryUserID
        if(item.DebitFromType.toLowerCase() == 'servicecenter') {
          debitDetailsP.VendorNameAndID = 'N/A'
          debitDetailsP.DebitID = item.DeliveryUserID
        } else if(item.DebitFromType.toLowerCase() == 'courier') {
          debitDetailsP.VendorNameAndID = `${item.AgencyName} ( ${item.SRAgencyID})`
          debitDetailsP.DebitID = item.CourierID
        } else {
          debitDetailsP.DebitID = item.DebitID
        }

        this.debitDetailsFull.push(debitDetailsP);
      }

    });

    this.debitPersonDetails = debitDetails[0].shipmentlostdebitdetails
    this.isScroll=this.debitDetailsFull.length>10? true:false;
  },
  closeDebitFromModal(){
    this.debitFromModal = false
  },
  handleSelectAll() {
    this.hubID = this.selectAll ? this.filteredHubList.map(option => option) : [];
  },
  getDashboardDetails(){
    this.detailsLoading=true;
    let reqdata = {
      userid : this.localuserid
    }
    axios.post(apiUrl.api_url + 'shipmentLost/LostDashboard/search', reqdata)
        .then((response) => {
          if(response.data.code == 200){
            // console.log(response.data,"->>>>>>>>>>")
            this.overAllDetails=response.data;
            this.GrantTotalRecovedYTD=parseFloat(this.overAllDetails.GrantTotalRecovedYTD? this.overAllDetails.GrantTotalRecovedYTD:0);
            this.GrandTotalRMApproveYTD=parseFloat(this.overAllDetails.GrandTotalRMApproveYTD? this.overAllDetails.GrandTotalRMApproveYTD:0);
            this.RMApprovalCount=parseInt(this.overAllDetails.RMApprovalCount? this.overAllDetails.RMApprovalCount:0);
            this.RecoveredAmountCount=parseInt(this.overAllDetails.RecoveredAmountCount? this.overAllDetails.RecoveredAmountCount:0);
            var approvalDetails= response.data.data;
            approvalDetails.map(element=>{
                            //RMApproveCalculated
                          element['RMALastMonth']=element.data.RMApproveCalculated.getRMApprovePendingCountlast1stMonth?
                                                  element.data.RMApproveCalculated.getRMApprovePendingCountlast1stMonth.totalDebitAmount:
                                                  '0';
                          element['RMA2ndLastMonth']=element.data.RMApproveCalculated.getRMApprovePendingCountlast2ndMonth?
                                                    element.data.RMApproveCalculated.getRMApprovePendingCountlast2ndMonth.totalDebitAmount:
                                                    '0';
                          element['RMA3rdLastMonth']=element.data.RMApproveCalculated.getRMApprovePendingCountlast3rdMonth?
                                                    element.data.RMApproveCalculated.getRMApprovePendingCountlast3rdMonth.totalDebitAmount:
                                                    '0';
                          element['RMAmtd']=element.data.RMApproveCalculated.getRMApprovePendingCountcurrentMonthPeriod?
                                            element.data.RMApproveCalculated.getRMApprovePendingCountcurrentMonthPeriod.totalDebitAmount:
                                            '0';
                          element['RMAytd']=element.data.RMApproveCalculated.getRMApprovePendingCountytdPeriod?
                                            element.data.RMApproveCalculated.getRMApprovePendingCountytdPeriod.totalDebitAmount:
                                            '0 ';
                          element['RMAytdCount']=element.data.RMApproveCalculated.getRMApprovePendingCountytdPeriod?
                                                element.data.RMApproveCalculated.getRMApprovePendingCountytdPeriod.count:
                                                '0 ';


                          //FullyRecoveredCalculated
                          element['FRLastMonth']=element.data.FullyRecoveredCalculated.getFullyRecoveredlast1stMonth?
                                                element.data.FullyRecoveredCalculated.getFullyRecoveredlast1stMonth.totalRecoveredAmount:
                                                '0';
                          element['FR2ndLastMonth']=element.data.FullyRecoveredCalculated.getFullyRecoveredlast2ndMonth?
                                                  element.data.FullyRecoveredCalculated.getFullyRecoveredlast2ndMonth.totalRecoveredAmount:
                                                  '0';
                          element['FR3rdLastMonth']=element.data.FullyRecoveredCalculated.getFullyRecoveredlast3rdMonth?
                                                    element.data.FullyRecoveredCalculated.getFullyRecoveredlast3rdMonth.totalRecoveredAmount:
                                                    '0';
                          element['FRmtd']=element.data.FullyRecoveredCalculated.getFullyRecoveredcurrentMonthPeriod?
                                          element.data.FullyRecoveredCalculated.getFullyRecoveredcurrentMonthPeriod.totalRecoveredAmount:
                                          '0';
                          element['FRytd']=element.data.FullyRecoveredCalculated.getFullyRecoveredytdPeriod?
                                          element.data.FullyRecoveredCalculated.getFullyRecoveredytdPeriod.totalRecoveredAmount:
                                          '0';
                          element['FRytdCount']=element.data.FullyRecoveredCalculated.getFullyRecoveredytdPeriod?
                                                element.data.FullyRecoveredCalculated.getFullyRecoveredytdPeriod.count:
                                                '0';


            })

            // let encryptedDetails = CryptoJS.AES.encrypt(JSON.stringify(this.overAllDetails), this.userDataKey);
            // window.localStorage.setItem('approvalDetails',encryptedDetails);
            var filterZoneData=approvalDetails.filter(element=>{
              return element.HubZoneId === this.hubZoneList['0'].HubZoneId
            })
            // console.log("=======<<<<<<<<<<<<<<<<<<<<", filterZoneData)
            var details=[];
            if(approvalDetails.length>10){
              for(let i=0; i<10;i++){
                details.push(filterZoneData[i])
              }
              this.dashboardDetails=details;
            }else{
              this.dashboardDetails=approvalDetails;
            }

            // console.log("details", details)
            // this.dashboardDetails=approvalDetails;
             this.detailsLoading=false;

          }else if(response.data.code == 204) {
            this.detailsLoading=false;
            this.$alertify.error("No Pending Approval");
          }else if(response.data.code == 202) {
            this.detailsLoading=false;
            this.$alertify.error(response.data.message);
          }else {
            this.detailsLoading=false;
            this.$alertify.error(response.data.message);
          }
        })
      .catch((httpException) => {
          console.error('exception is:::::::::',httpException)
      });
  },
  showMoreData(){
    // this.$router.push('/RMApproveDashboard')
    const route = this.$router.resolve('/RMApproveDashboard' ); // specify your route by name or path
      window.open(route.href, '_blank');

  },
  openModal(item) {
    this.Itemselected = item;
    this.getAttachmentFlag=false;
    this.showModal = true;
  },
  closeModal() {
    this.showModal = false;
    this.Itemselected = null;
    this.getAttachmentFlag=true;
  },
  getModifiedStatus(status) {
    return status ? this.$options.filters.modifyDebitStaus(status) : '-'
  }

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    moment2: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    },
    updateSourceTypelabel: function(source, isPotentialLost) {
      if (source == null)
        return '--'

      if(source == 'autoPendency' && isPotentialLost == true) {
        return 'Potential Lost'
      } else if(source == 'autoPendency') {
        return 'Auto Lost Notified by System'
      } else if (source == 'applicationLost') {
        return 'lost notified manually'
      } else if (source == 'autoLostCron') {
        return 'Auto Pickup Loss';
      } else {
        return '--'
      }
    },
    modifyDebitStaus: function(modifyDebitStaus) {
      if(modifyDebitStaus && modifyDebitStaus == 'Pending') {
        return 'Defaulter Identified';
      } else {
        return 'Defaulter N/A';
      }
    }
  },
}
$('.pane-hScroll').scroll(function() {
  $('.pane-vScroll').width($('.pane-hScroll').width() + $('.pane-hScroll').scrollLeft());
});



// WEBPACK FOOTER //
// ./src/views/components/LOST/RMApprove/RMApprove.component.js